import { render, staticRenderFns } from "./Postanestecia.vue?vue&type=template&id=3026a036"
import script from "./Postanestecia.vue?vue&type=script&lang=js"
export * from "./Postanestecia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports